import React from 'react';
import { isLastElement } from 'globals/utils';
import { TransactionType } from 'globals/types';
import { Box } from '@material-ui/core';
import FsTransactionRowWithBarGraph from './FsTransactionRowWithBarGraph';
import { FsTransactionRowWithBarGraphDataProps } from './FsTransactionRowWithBarGraph/FsTransactionRowWithBarGraph';

interface FsTransactionRowsWithBarGraphProps {
  rows: FsTransactionRowWithBarGraphDataProps[];
  type: TransactionType;
}

const FsTransactionRowsWithBarGraph: React.FC<FsTransactionRowsWithBarGraphProps> = ({
  rows,
  type,
}) => {
  return (
    <Box>
      {rows.map(({ id, ...otherProps }, idx) => (
        <FsTransactionRowWithBarGraph
          {...otherProps}
          last={isLastElement(idx, rows.length)}
          key={id}
          id={id}
          type={type}
          data-test="report-transaction-row"
        />
      ))}
    </Box>
  );
};

export default FsTransactionRowsWithBarGraph;
